import { Button } from "../CommonUIComponents/Button/Button";
import { EditIcon } from "../../icons/editIcon";
import { DeleteIcon } from "../../icons/delete";

export const getUserColumnDefs = (
  handleEditUser,
  handleDeleteUser,
  handleViewUser,
  currentUserEmail,
  t,
) => {
  const _t = typeof t === "function" ? t : (k) => k;
  const normalizedCurrentEmail = (currentUserEmail || "").trim().toLowerCase();

  return [
    {
  field: "email",
  headerName: "User Email",
  tooltipField: "email",
  cellRenderer: (params) => (
    <span
      onClick={(e) => {
        e.stopPropagation();
        handleViewUser(params.data);
      }}
      style={{ cursor: "pointer" }}
    >
      {params.value}
    </span>
  ),
},
    {
      field: "processingTeamType",
      headerName: "Team",
      sortable: true,
      filter: false,
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => {
        const value = params.data?.processingTeamType;

        const team = Array.isArray(value)
          ? value[0]
          : value;

        if (team === "Nearshore") {
          return "Nearshore";
        }

        return team || "--";
      },
    },
    {
      field: "region",
      headerName: _t("user_mng_region"),
      sortable: true,
      filter: false,
      flex: 0.7,
      minWidth: 80,
    },
    {
      field: "coe",
      headerName: _t("user_mng_coe"),
      sortable: true,
      filter: false,
      flex: 0.5,
      minWidth: 60,
    },
    {
      field: "role",
      headerName: _t("user_mng_role"),
      sortable: true,
      filter: false,
      flex: 1.8,
      minWidth: 170,
    },
    {
      field: "isActive",
      headerName: _t("user_mng_isActive"),
      sortable: true,
      filter: false,
      flex: 0.7,
      minWidth: 80,
      cellRenderer: (params) => {
        return (
          <span
            className={`user-status ${
              params.value ? "user-status-active" : "user-status-inactive"
            }`}
          >
            {params.value ? "True" : "False"}
          </span>
        );
      },
    },
    {
      field: "action",
      headerName: _t("action"),
      sortable: false,
      filter: false,
      flex: 0.7,
      minWidth: 110,
      cellRenderer: (params) => {
        const NON_EDITABLE_ROLES = [
          "Engagement Manager",
          "Admin",
          "Resource Manager/PMO",
        ];
        const NON_DELETABLE_ROLES = ["Engagement Manager"];
        const rowRole = params.data.role;
        const rowRoles = Array.isArray(rowRole) ? rowRole : [rowRole];
        const isNonEditable = rowRoles.some((r) =>
          NON_EDITABLE_ROLES.includes(r),
        );
        const isNonDeletable = rowRoles.some((r) =>
          NON_DELETABLE_ROLES.includes(r),
        );

        const rowEmail = (params.data.email || "").trim().toLowerCase();
        const isSelf =
          normalizedCurrentEmail && rowEmail === normalizedCurrentEmail;
        const canDelete = !isSelf && !isNonDeletable;

        if (isNonEditable && !canDelete) return null;

        return (
          <div className="user-action-buttons">
            {!isNonEditable && (
              <Button
                onClick={() => handleEditUser(params.data.id)}
                aria-label="Edit user"
                variant="secondary"
                size="small"
                type="button"
              >
                <EditIcon />
              </Button>
            )}
            {canDelete && (
              <Button
                onClick={() => handleDeleteUser(params.data.id)}
                aria-label="Delete user"
                variant="secondary"
                size="small"
                type="button"
              >
                <DeleteIcon />
              </Button>
            )}
          </div>
        );
      },
    },
  ];
};
